import Level from "../Enums/Logger/Levels";
class Logger {
    static handler(event, detail, level) {
        const data = detail || {};
        if (typeof window.DD_LOGS === 'undefined' || typeof window.DD_LOGS.logger === 'undefined') {
            return;
        }
        switch (level) {
            case Level.DEBUG:
                window.DD_LOGS.logger.debug(event, data);
                break;
            case Level.INFO:
                window.DD_LOGS.logger.info(event, data);
                break;
            case Level.WARN:
                window.DD_LOGS.logger.warn(event, data);
                break;
            case Level.ERROR:
                window.DD_LOGS.logger.error(event, data);
                break;
            default:
                window.DD_LOGS.logger.log(event, data);
                break;
        }
    }
    static log(event, detail = {}, level = Level.INFO) {
        if (level <= this.level) {
            this.handler(event, detail, level);
        }
    }
    static debug(event, detail = {}) {
        this.log(event, detail, Level.DEBUG);
    }
    static info(event, detail = {}) {
        this.log(event, detail, Level.INFO);
    }
    static warn(event, detail = {}) {
        this.log(event, detail, Level.WARN);
    }
    static error(event, detail = {}) {
        this.log(event, detail, Level.ERROR);
    }
    static setLevel(level) {
        this.level = level;
        return true;
    }
    static setGlobalContext(context) {
        if (typeof window.DD_LOGS !== 'undefined' && typeof window.DD_LOGS.setGlobalContext !== 'undefined') {
            window.DD_LOGS.setGlobalContext(context);
        }
    }
    static addGlobalContext(contextArray) {
        if (typeof window.DD_LOGS !== 'undefined' && typeof window.DD_LOGS.setGlobalContext !== 'undefined') {
            let ctx = window.DD_LOGS.getGlobalContext() || {};
            window.DD_LOGS.setGlobalContext(Object.assign(Object.assign({}, ctx), contextArray));
        }
    }
    static setHandler(handler) {
        if (typeof handler === 'function') {
            this.handler = handler;
        }
    }
}
Logger.level = Level.WARN;
export default Logger;
